export default "__VITE_ASSET__QJqHK_6s__"